import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#000\"><path fill=\"#000\" fill-rule=\"nonzero\" stroke-width=\".2\" d=\"M1.419 24h17.423c.23 0 .419-.204.419-.425V5.472c0-.11-.048-.222-.123-.272l-4.224-4.053v-.015A.44.44 0 0 0 14.618 1h-13.2A.43.43 0 0 0 1 1.425v22.15c0 .221.188.425.419.425ZM15.035 2.39l2.8 2.66h-2.8zm-13.2-.59H14.2v3.672c0 .222.188.378.418.378h3.808V23.2H1.835z\"></path><g stroke-linecap=\"round\"><path d=\"M9.384 8.696c-2.16.411-3.635 2.447-3.295 4.548a3.67 3.67 0 0 0 1.325 2.282 3.91 3.91 0 0 0 3.202.778c2.16-.411 3.635-2.447 3.295-4.548\"></path><path d=\"m12.458 12.766 1.26-1.764 1.613 1.294\"></path></g></g>", 1)
  ])))
}
export default { render: render }